import { queryStringToQueryId } from 'ducks/searches/utils/query'
import { selectQueryParams } from 'selectors/location'
import { emptyObj } from 'util/objects'
import { createBasicSelector } from 'util/redux'

const selectBase = state => state.tables || emptyObj

export const selectTableQueryIdFromUrlById = createBasicSelector(
  selectQueryParams,
  (_, tableId) => tableId,
  (pageQuery, tableId) => queryStringToQueryId(pageQuery, { targetId: tableId })
)

export const selectTablesById = createBasicSelector(
  selectBase,
  base => base.byId || emptyObj
)

export const selectTableById = createBasicSelector(
  selectTablesById,
  (_, tableId) => tableId,
  (byId, tableId) => {
    return byId[tableId] || emptyObj
  }
)

export const selectTableQueryById = createBasicSelector(
  selectTableById,
  table => {
    return table.query || emptyObj
  }
)

export const selectTableScrollPositionById = createBasicSelector(
  selectTableById,
  table => {
    return table.scrollPosition || 0
  }
)
